module.exports = "<span class=loader>{{text}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/templates/loading.hbs
// module id = 717
// module chunks = 0